import { Box, Skeleton } from "@mui/material";
import { type FC, useState } from "react";
import { BADGE, CONTROL_HEIGHT } from "@/theme/tokens";
import { type RandomRange, randomBetween, randomCount } from "./skeletonVariants";

/** How the list varies per mount: its row count, and each row's title and detail line width (% of the row's text). */
const LIST_RANGES = {
	rows: [5, 7],
	titleWidth: [35, 65],
	detailWidth: [45, 80],
} as const satisfies Record<string, RandomRange>;

/** A stack of rows, each an avatar, a title over a detail line and a trailing pill: a feed or a people list's shape. */
export const ListSkeletonVariant: FC = () => {
	const [rows] = useState(() =>
		Array.from({ length: randomCount(LIST_RANGES.rows) }, () => ({
			titleWidth: randomBetween(LIST_RANGES.titleWidth),
			detailWidth: randomBetween(LIST_RANGES.detailWidth),
		})),
	);

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
			{rows.map((row, index) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: placeholder rows are a fixed stack of bars; nothing reorders them.
				<Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
					<Skeleton variant="circular" sx={{ width: (theme) => theme.spacing(4), height: (theme) => theme.spacing(4), flexShrink: 0 }} />
					<Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
						<Skeleton variant="text" width={`${row.titleWidth}%`} />
						<Skeleton variant="text" width={`${row.detailWidth}%`} />
					</Box>
					<Skeleton variant="rounded" sx={{ width: "12%", height: CONTROL_HEIGHT.COMPACT, borderRadius: BADGE.PILL_RADIUS_FULL, flexShrink: 0 }} />
				</Box>
			))}
		</Box>
	);
};
